import * as React from 'react';

import { Box, Chip, Typography } from '@mui/material';
import * as clients from '../core/api/clients';

interface IFormStatus {
  status: clients.EventFormStatus | undefined;
  subtext: string | null | undefined;
}

function FormStatus({ status, subtext }: IFormStatus) {
  const getStatusColor = (statusText: clients.EventFormStatus | undefined) => {
    switch (statusText) {
      case clients.EventFormStatus.Draft: return 'info';
      case clients.EventFormStatus.Submitted: return 'warning';
      case clients.EventFormStatus.Approved: return 'success';
      case clients.EventFormStatus.Final: return 'primary';
      case clients.EventFormStatus.Deleted: return 'error';
      default: return undefined;
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      marginBottom={1}
      marginRight={1}
    >
      <Box
        display="flex"
        justifyContent="flex-end"
      >
        <Chip variant="outlined" label={status} color={getStatusColor(status)} />
      </Box>
      {(subtext !== undefined)
      && <Typography color={getStatusColor(status)} variant="caption">{subtext}</Typography>}
    </Box>
  );
}

export default FormStatus;
